import { __assign, __decorate, __extends, __metadata, __rest } from "tslib";
import React from 'react';
import { Utils } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import BasicPagerControls from './BasicPagerControls';
import Loader from '../Loader';
import { DataViewContext, DataViewContextParams } from '../../React/DataView';
var Pager = /** @class */ (function (_super) {
    __extends(Pager, _super);
    function Pager(props) {
        var _this = _super.call(this, props) || this;
        _this.dataViewContext = new DataViewContextParams();
        _this.dataViewContext.dataView = _this.props.pageManager;
        return _this;
    }
    Pager.prototype.componentDidMount = function () {
        this.props.pageManager.initialise();
    };
    Pager.prototype.componentDidUpdate = function () {
        this.props.pageManager.afterRender();
    };
    Pager.prototype.render = function () {
        var _a = this.props, pageManager = _a.pageManager, pageControls = _a.pageControls, pageControlProps = _a.pageControlProps, suppressLoader = _a.suppressLoader, hideBeforeLoad = _a.hideBeforeLoad, domProps = __rest(_a, ["pageManager", "pageControls", "pageControlProps", "suppressLoader", "hideBeforeLoad"]);
        if (!pageManager.hasFetched && !pageManager.taskRunner.isBusy && hideBeforeLoad !== false) {
            return null;
        }
        var className = Utils.joinWithSpaces("neo-pager", domProps.className);
        var pager = React.createElement("div", __assign({}, domProps, { className: className }),
            pageManager.hasFetched && pageControls && (pageControls === "top" || pageControls === "topAndBottom") &&
                React.createElement("div", { className: "pager-controls-container-top" },
                    React.createElement(BasicPagerControls, __assign({}, pageControlProps, { ref: undefined, pageManager: pageManager }))),
            React.createElement(DataViewContext.Provider, { value: this.dataViewContext }, this.props.children instanceof Function ? this.props.children(pageManager.getItems()) : this.props.children),
            pageManager.hasFetched && (!pageControls || pageControls === "bottom" || pageControls === "topAndBottom") &&
                React.createElement("div", { className: "pager-controls-container-bottom" },
                    React.createElement(BasicPagerControls, __assign({}, pageControlProps, { ref: undefined, pageManager: pageManager }))));
        return suppressLoader ? pager : React.createElement(Loader, { task: pageManager.taskRunner }, pager);
    };
    Pager = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Pager);
    return Pager;
}(React.Component));
export default Pager;
